var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50733 3.32725C4.56092 1.48057 6.07478 0 7.93443 0H10.0977L12.3159 3.32725H9.67766L7.47946 0.0299456C7.1308 0.0761732 6.79867 0.174797 6.49126 0.317645L8.49766 3.32725H4.50733ZM4.50586 3.42857C4.50586 3.39468 4.50635 3.3609 4.50733 3.32725H4.50586V3.42857ZM4.50586 4.30906V8.57143C4.50586 10.465 6.04088 12 7.93443 12H13.0773C14.9708 12 16.5059 10.465 16.5059 8.57143V4.30906H4.50586ZM16.5059 3.42857V3.32725H16.5044C16.4508 1.48057 14.9369 0 13.0773 0H11.2777L13.4959 3.32725H16.5044C16.5054 3.3609 16.5059 3.39468 16.5059 3.42857ZM12.2731 7.26918C12.4622 7.38188 12.4622 7.66362 12.2731 7.77631L9.29495 9.55127C9.10586 9.66396 8.8695 9.52309 8.8695 9.2977L8.8695 5.74779C8.8695 5.5224 9.10586 5.38153 9.29495 5.49423L12.2731 7.26918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelIcon);
export default __webpack_public_path__ + "static/media/reel-icon.f96c82fbc78b1fef06280123c20c946f.svg";
export { ForwardRef as ReactComponent };